import { jsx as _jsx } from "react/jsx-runtime";
/** Stable cycle path without returnTo — keeps matrix links from churning on filter changes. */
export function cyclePath(displayNumber) {
    return `/engagements/cycles/${encodeURIComponent(displayNumber)}`;
}
/**
 * Primary click opens the cycle with the current board returnTo.
 * Modified clicks (new tab) use the stable path without query.
 */
export function CycleNavLink({ displayNumber, onOpenCycle, className, 'aria-label': ariaLabel, children, }) {
    return (_jsx("a", { href: cyclePath(displayNumber), className: className, "aria-label": ariaLabel, onClick: (event) => {
            if (event.defaultPrevented)
                return;
            if (event.button !== 0)
                return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                return;
            }
            event.preventDefault();
            onOpenCycle(displayNumber);
        }, children: children }));
}
